<script lang="ts">
    import cn from '$common/utils/cn';

    const {
        class: className,
        color = 'var(--vp-semantic-color-content-brand)',
    }: {
        class?: string;
        color?: 'var(--vp-semantic-color-content-brand)' | 'white';
    } = $props();
</script>

<span
    class={cn(className, 'vp-loader h-2xl w-2xl inline-block')}
    style:--loader-conic-gradient-start={color}
    data-part="root"
    aria-hidden="true"
>
</span>

<style lang="postcss">
    .vp-loader {
        --loader-timing-function: var(
            --vp-semantic-motion-easing-expressive-ease-in-out
        );
        --loader-duration: var(--vp-semantic-motion-duration-slow);
        transform: skew(-20deg, -10deg) rotate(-40deg);
        --loader-conic-gradient-end: transparent;
    }

    .vp-loader:before {
        background: conic-gradient(
            var(--loader-conic-gradient-start),
            var(--loader-conic-gradient-end) 85%
        );
        -webkit-mask: radial-gradient(farthest-side, #0000 80%, #000 0);
        mask: radial-gradient(farthest-side, #0000 80%, #000 0);
    }
    .vp-loader:before {
        @apply absolute block h-full w-full rounded-full;
        animation: vp-loader infinite;
        animation-duration: var(--loader-duration);
        animation-timing-function: var(--loader-timing-function);
        content: '';
    }

    @keyframes vp-loader {
        100% {
            rotate: -1turn;
        }
    }
</style>
